import { PipelineStage } from '../types/pipeline.types';

// Stage icons (using emoji for now, can be replaced with icon components)
export const STAGE_ICONS = ['📋', '🔍', '📊', '✅', '📝', '🏁', '💼', '⚡', '📧', '✔️', '📤'];

export const PIPELINE_STAGES: PipelineStage[] = [
  { id: 10, label: 'Bureau à encoder', description: 'Dossier tout juste créé', color: '#ff6b6b', icon: '📋' },
  { id: 20, label: 'Bureau à planifier', description: 'Préparation / prise de rendez-vous', color: '#ff8e53', icon: '🔍' },
  { id: 30, label: 'RV en attente', description: 'RV en attente de planification', color: '#f39c12', icon: '📊' },
  { id: 40, label: 'Expert à visiter', description: 'Visite terrain à organiser', color: '#e67e22', icon: '✅' },
  { id: 50, label: 'Expert à achever', description: 'Rapport d\'expertise à boucler', color: '#f1c40f', icon: '📝' },
  { id: 60, label: 'Bureau à valoriser', description: 'Rapport d\'expertise à valoriser', color: '#52c41a', icon: '🏁' },
  { id: 70, label: 'Bureau à achever', description: 'Rapport d\'expertise à achever', color: '#1890ff', icon: '💼' },
  { id: 80, label: 'Attente doc/infos', description: 'Attentes administratives', color: '#722ed1', icon: '⚡' },
  { id: 90, label: 'Attente paiement', description: 'Attentes paiements, relances', color: '#eb2f96', icon: '📧' },
  { id: 100, label: 'Attente confirmation', description: 'Validations externes', color: '#13c2c2', icon: '✔️' },
  { id: 110, label: 'À transmettre', description: 'Prêt à être envoyé', color: '#52c41a', icon: '📤' }
];

export const STATUS_MAPPING: Record<string, number> = {
  // Stage 10 - Dossier tout juste créé
  'bureau à encoder': 10,
  'bureau a encoder': 10,
  
  // Stage 20 - Préparation / prise de rendez-vous
  'bureau à planifier': 20,
  'bureau a planifier': 20,
  
  // Stage 30 - RV en attente de planification
  'rv en attente*': 30,
  
  // Stage 40 - Visite terrain à organiser
  'expert à visiter': 40,
  'expert a visiter': 40,
  
  // Stage 50 - Rapport d'expertise à boucler
  'expert à achever': 50,
  'expert a achever': 50,
  
  // Stage 60 - Rapport d'expertise à valoriser
  'bureau à valoriser': 60,
  'bureau a valoriser': 60,
  
  // Stage 70 - Rapport d'expertise à achever
  'bureau à achever': 70,
  'bureau a achever': 70,
  '*à achever': 70,
  '*a achever': 70,
  
  // Stage 80 - Attentes administratives: docs
  'attente doc/infos': 80,
  'attente documents/infos': 80,
  
  // Stage 90 - Attentes paiements
  'attente paiement*': 90,
  'attente de paiement + conf': 90,
  'demande annulee + att paiement client': 90,
  'attente de facturation': 90,
  '*rappel paiement client': 90,
  '1er rappel paiement courtier': 90,
  '2eme rappel paiement courtier': 90,
  '3eme rappel paiement courtier sms': 90,
  '3eme rappel tf + mail (menace solvency)': 90,
  '*rappel paiement courtier*': 90,
  'attente de facturation mensuelle': 90,
  'solvency': 90,
  
  // Stage 100 - Validations externes
  'attente confirmation*': 100,
  'facture en attente confirmation': 100,
  'mandat de vente en cours': 100,
  
  // Stage 110 - Prêt à être envoyé
  'à transmettre': 110,
  'a transmettre': 110
};

// Sort options for the pipeline
export const SORT_OPTIONS = [
  { value: 'urgency', label: 'Urgence' },
  { value: 'date', label: 'Date création' },
  { value: 'date_rv', label: 'Date RV' },
  { value: 'expert', label: 'Expert' },
  { value: 'client', label: 'Client' },
  { value: 'amount', label: 'Montant' },
  { value: 'type', label: 'Type' },
  { value: 'id', label: 'Référence' }
];

// Special sorting for specific stages
export const STAGE_DEFAULT_SORT: Record<number, string> = {
  40: 'date_rv', // Expert à visiter - sort by appointment date by default
  90: 'date_rv', // Attente paiement - sort by appointment date by default
};

// Filter options for the pipeline
export const FILTER_OPTIONS = [
  { key: 'all', label: 'Tous' },
  { key: 'urgent', label: 'Urgent' },
  { key: 'delayed', label: 'En retard' },
  { key: 'assigned', label: 'Assigné' },
  { key: 'unassigned', label: 'Non assigné' }
];